import React from 'react'

export default function TNPSCMain() {
  return (
    <div> ** construction ** </div>
  )
}
